module.exports = __webpack_public_path__ + "img/blue_141.fd0265f0.png";